import script from "./ParticipantCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantCard.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantCard.vue?vue&type=style&index=0&id=10f61e44&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f61e44"]])

export default __exports__